import { Box, Card, CardContent, Tab, Tabs, useMediaQuery } from '@mui/material';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@emotion/react';
import ManageLeaves from './manageLeaves';

function ApproveLeaveTabs(props) {
    const navigate = useNavigate();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

const [activeTab, setActiveTab] = useState({
        value : 0,
        label : 'Pending'
    });
    const handleTabChange = (event, newValue) => {
        setActiveTab({value : newValue, label : event?.target.innerText});    };

    const renderTabContent = () => {
        return <ManageLeaves key={activeTab.label} action={activeTab} modulePermissions={props.modulePermissions.Payrole} permissions={props.permissions} />;
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Card sx={{ pt: 1, mt: 2 }}>
                <Box>
                    <CardContent>
                        <Box
                            sx={{
                                //bgcolor: 'background.paper',
                                border: 'none',
                                display: "flex",
                                flexDirection: isSmallScreen ? "column" : "row",
                                alignItems: "center",
                                justifyContent: isSmallScreen ? "flex-start" : "center",
                                gap: 1,
                            }}
                        >
                            <Tabs
                                value={activeTab.value}
                                onChange={handleTabChange}
                                centered={!isSmallScreen}
                                orientation={isSmallScreen ? "vertical" : "horizontal"}
                                sx={{
                                    width: "100%",
                                    "& .MuiTab-root": {
                                        fontSize: isSmallScreen ? "0.8rem" : "1rem",
                                    },
                                }}
                            >
                                <Tab label="Pending" />
                                <Tab label="Approved" />
                                <Tab label="Rejected" />
                            </Tabs>
                        </Box>
                    </CardContent>
                </Box>
            </Card>
            {/* Render ManageLeaves Component */}
            <Box sx={{ marginTop: 2 }}>
                {renderTabContent()}
            </Box>
        </DashboardLayout>
    );
}

export default ApproveLeaveTabs;
